import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

const Shell = ({ code, title, sub }) => (
  <div className="min-h-screen grid place-items-center bg-[#F8FAFC] px-6">
    <div className="text-center animate-fade-up">
      <div className="flex justify-center"><Logo size={34} /></div>
      <p className="mt-12 font-display text-[100px] leading-none font-bold grad-text">{code}</p>
      <h1 className="mt-4 font-display text-2xl font-semibold text-slate-900">{title}</h1>
      <p className="mt-3 max-w-md text-sm text-slate-500">{sub}</p>
      <Link to="/dashboard">
        <Button className="mt-8 h-11 rounded-xl grad-brand text-white px-7" data-testid="error-back-button">Kembali ke Dashboard</Button>
      </Link>
    </div>
  </div>
);

export const NotFound = () => (
  <Shell code="404" title="Halaman tidak ditemukan" sub="Tautan yang Anda buka mungkin sudah dipindahkan atau dihapus." />
);

export const ServerError = () => (
  <Shell code="500" title="Terjadi kesalahan server" sub="Sistem VECTRA sedang mengalami gangguan. Tim teknis telah diberi notifikasi." />
);
